import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findUserTransactions = (headers, params) => {
    let query = buildQuery(params, [], ["startDate", "endDate"]);

    if (params?.filters?.startDate?.value) {
        query += `${params.filters.username.value ? ";" : ""}requestDate=ge=${params.filters.startDate.value?.replaceAll("-", "")}`;
    }
    if (params.filters.endDate.value) {
        query += `;requestDate=le=${params.filters.endDate.value?.replaceAll("-", "")}`;
    }
    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/user-transactions${query}`, {
        headers,
    });
};
